import { isDefined } from "@omni/utils/helper.utils";
import { createContext, Dispatch, ReactNode, SetStateAction, use } from "react";

type ClickAndCollectContextValue = {
    setIsStorePickerOpen: Dispatch<SetStateAction<boolean>>;
};

type ClickAndCollectContextProviderProps = {
    setIsStorePickerOpen: Dispatch<SetStateAction<boolean>>;
    children: ReactNode;
};

export const ClickAndCollectContext = createContext<
    ClickAndCollectContextValue | undefined
>(undefined);

export const ClickAndCollectContextProvider = ({
    setIsStorePickerOpen,
    children
}: ClickAndCollectContextProviderProps) => {
    return (
        <ClickAndCollectContext.Provider
            value={{ setIsStorePickerOpen: setIsStorePickerOpen }}
        >
            {children}
        </ClickAndCollectContext.Provider>
    );
};

export const useClickAndCollectContext = () => {
    const context = use<ClickAndCollectContextValue | undefined>(
        ClickAndCollectContext
    );

    if (!isDefined(context)) {
        throw new Error(`${ClickAndCollectContext.displayName} is undefined.`);
    }

    return context;
};
